export const formatNumber = (number, minPrecision = 0, maxPrecision = 8) => {
  const newNumber = Number(number);
  const options = {
    minimumFractionDigits: minPrecision,
    maximumFractionDigits: maxPrecision,
  }
  return newNumber.toLocaleString(undefined, options)
}

export const formatAddress = (address) => {
  return `${address.substring(0, 5)}…${address.substring(address.length - 4)}`;
}
